import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";

export interface IMediaFilter {
    (mediaPath: string): string;
}
// declare module "angular" {
//     interface IFilterService {
//         (name: "media"): IMediaFilter;
//     }
// }

@NgFilter({
    token: Token.MediaFilter,
    dependencies: [
        Token.StorageService
    ]
})
export class MediaFilter {
    constructor(
        storageService: StorageService
    ) {
        return ((mediaPath: string) => {
            if (!mediaPath) {
                return storageService.getFallbackImage();
            } else {
                return storageService.getMediaUrl(mediaPath);
            }
        }) as IMediaFilter as any;
    }

}
